import * as React from "react";

interface SelectedFacetsProps {
    data: any[]
    onFacetChange: (facet: any) => void
    overlay?: boolean
}


export const SelectedFacets = (props: SelectedFacetsProps) => {
    const classes = ["c-selected-facets"];
    if(props.overlay) classes.push("c-selected-facets--overlay");

    const toggleSelected = facet => {
        // tslint:disable-next-line:no-string-literal
        facet.options[0]["selected"] = false;
        props.onFacetChange(facet);
    };

    return (
        <div className={classes.join(" ")}>
            <div className="c-selected-facets__title">you refined by</div>
            <div className="c-selected-facets__options">
                {props.data.map((group, groupIndex) => (
                    <div className="c-selected-facets__group" key={group.key}>
                        {group.options.map((option, optionIndex) => (
                            <div className="c-selected-facets__option" key={option.value}>
                                <span className="c-selected-facets__label">{option.label}</span>
                                <span className="c-selected-facets__undo">
                                    (<span
                                        className="c-link c-link--magenta"
                                        onClick={() => toggleSelected(group)}>
                                        undo
                                    </span>)
                                </span>
                            </div>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default SelectedFacets;
